<script lang="ts" module>
  // Module-scoped because Svelte 5 instance scripts can't `export type` directly.
  // ThemeTab and other call sites import this to type their snippet parameters.
  export type RadioOption = {
    value: string;
    label: string;
    description?: string;
  };
</script>

<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    value,
    options = [],
    columns = 3,
    onChange = (_value: string) => {},
    preview,
  }: {
    value: string;
    options?: readonly RadioOption[];
    columns?: number;
    onChange?: (value: string) => void;
    // Svelte 5 snippet — receives the option being rendered so call sites can
    // reactively render live previews using $theme etc. Preferred over the
    // earlier `(option) => string` shape which broke reactivity and forced
    // `{@html}` injection.
    preview?: Snippet<[RadioOption]>;
  } = $props();
</script>

<div
  class={`grid gap-2 ${
    columns === 2
      ? 'grid-cols-2'
      : columns === 4
        ? 'grid-cols-2 lg:grid-cols-4'
        : columns === 5
          ? 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5'
          : 'grid-cols-3'
  }`}
>
  {#each options as option}
    <button
      type="button"
      class={`rounded-2xl border bg-surface p-3 text-left transition ${
        value === option.value
          ? 'border-gray-900 dark:border-gray-200 ring-1 ring-gray-900 dark:ring-gray-200'
          : 'border-default hover:border-gray-300 dark:hover:border-gray-500 hover:bg-gray-50 dark:hover:bg-dark-elevated'
      }`}
      onclick={() => onChange(option.value)}
    >
      {#if preview}
        <div class="mb-3">{@render preview(option)}</div>
      {/if}
      <div class="text-sm font-semibold text-content">{option.label}</div>
      {#if option.description}
        <div class="mt-1 text-xs leading-5 text-content-secondary">{option.description}</div>
      {/if}
    </button>
  {/each}
</div>
